<template>
  <div class="hscroll">
    <div class="hscroll-container">
      <div class="item-hscroll" v-for="(item, key) in attributes.value" :key="key" :style="{width: setItemWidth(item.width)}">
        <st-get-svg
          :rootFolder="getSvgFolder(item.svg)"
          :platform="getSvgName(item.svg)"
          ></st-get-svg>
      </div>
    </div>
    <div v-if="componentWidth && showHint()" class="hswipe-hint">
      <img :src="getSource('project/hand-icon.svg')" alt="" />
    </div>
  </div>
</template>

<script>
import StGetSvg from '../../SvgFolder/StGetSvg.vue'

export default {
  props: ['attributes'],
  components: {
    StGetSvg
  },
  data () {
    return {
      deviceWidth: document.documentElement.clientWidth,
      componentWidth: 0
    }
  },
  methods: {
    getSource (value) {
      if (!value) return null
      return require(`images/${value}`)
    },
    getSvgFolder (str) {
      var arrFolder = str.split('/')
      arrFolder.pop()
      return arrFolder.join('/')
    },
    getSvgName (str) {
      var arrName = str.split('/')
      const name = arrName.pop()
      return name.replace('.svg', '')
    },
    setItemWidth (width) {
      if (this.deviceWidth < 768) {
        return '100%'
      }
      return width
    },
    showHint () {
      if (this.attributes.value.length < 2) return false
      var totalWidth = 0
      const elements = this.$el.querySelectorAll('.item-hscroll')
      elements.forEach((el) => {
        totalWidth += el.clientWidth
      })
      if (totalWidth <= this.componentWidth) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.componentWidth = this.$el.clientWidth
    if (!window.matchMedia('(pointer: coarse)').matches) {
      // no touchscreen
      this.$el.querySelector('.hscroll-container').classList.add('no-touch')
    }
  }
}
</script>

<style lang="scss">
.hscroll {
  position: relative;
  width: 100%;
  overflow: hidden;
  .hscroll-container {
    max-width: 100%;
    white-space: nowrap;
    display: block;
    text-align: center;
    overflow-x: auto;
    &:hover {
      &::-webkit-scrollbar {
        -webkit-appearance: none;
      }
      &::-webkit-scrollbar:horizontal {
        height: 11px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 2px solid white; /* should match background, can't be transparent */
        background-color: rgba(0, 0, 0, .5);
        width: 20px !important;
        background-clip: content-box;
      }
    }
    .item-hscroll {
      white-space: nowrap;
      display: inline-block;
    }
  }
}
.hswipe-hint {
  padding-top: 10px;
  text-align: center;
  img {
    position: relative;
    animation: hswipeAnimation 5s infinite;
    width: 25px;
  }
}
@keyframes hswipeAnimation {
  0% {
    left: -10px;
  }
  50% {
    left: 10px;
  }
  100% {
    left: -10px;
  }
}
</style>
